import React, { useState, useEffect, useRef } from 'react';
import queryString from 'query-string';
import { Form, Progress, Alert } from 'reactstrap';
import { CSSTransition } from 'react-transition-group';

import { useLocalization } from '../../containers/I18nProvider';
import { WithCaptcha } from '../../containers/captcha';
import logo from './img/logo.png';

const LoginForm = ({ api, location, TurnstileComponent, ...props }) => {
  const nodeRef = useRef(null);
  const { translate, changeDefaultLocale } = useLocalization();

  useEffect(() => {
    changeDefaultLocale('es');
    setShowForm(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const [onLogin, setOnLogin] = useState(false);
  const [showForm, setShowForm] = useState(false);
  const [error, setError] = useState({ open: false, message: '' });
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');

  const parameters = queryString.parse(location.search);

  const onSubmit = async (ev) => {
    ev.preventDefault();
    setOnLogin(true);
    setError({ open: false, message: '' });

    api
      .userPassLogin({ username, password }, parameters)
      .then((response) => {
        setOnLogin(false);
        window.location = parameters.redirect_uri + '?' + queryString.stringify(response);
      })
      .catch((error) => {
        const _translate = translate(error.errorCode);
        let message = translate('RequestLoginErrorMessage');
        if (_translate) {
          message = _translate;
        } else if (error.details) {
          message = error.details;
        }
        setOnLogin(false);
        setError({ open: true, message });
      });
  };

  return (
    <div className="jjnet-wrapper jjnet-inner-page">
      <div className="jjnet-center-panel">
        <div className="jjnet-logo">
          <img src={logo} alt="JJ Net" />
        </div>
        <p className="jjnet-lead">{translate('Subtitle')}</p>
        <CSSTransition
          in={showForm}
          timeout={300}
          classNames="formshow"
          nodeRef={nodeRef}
          unmountOnExit
        >
          <div className="jjnet-card" ref={nodeRef}>
            <Form onSubmit={(event) => onSubmit(event)} className="jjnet-form">
              <div className="jjnet-form-group">
                <input
                  type="text"
                  className="jjnet-input"
                  placeholder={translate('PlaceholderUserName')}
                  id="jjnet-username"
                  name="login"
                  autoCorrect="off"
                  autoCapitalize="none"
                  aria-label={translate('PlaceholderUserName')}
                  disabled={onLogin}
                  required
                  tabIndex={1}
                  onChange={(e) => setUsername(e.target.value)}
                />
              </div>
              <div className="jjnet-form-group">
                <input
                  type="password"
                  className="jjnet-input"
                  placeholder={translate('PlaceholderPassword')}
                  id="jjnet-password"
                  name="senha"
                  aria-label={translate('PlaceholderPassword')}
                  disabled={onLogin}
                  required
                  tabIndex={2}
                  onChange={(e) => setPassword(e.target.value)}
                />
              </div>
              {!onLogin ? (
                <button
                  type="submit"
                  className="jjnet-btn"
                  disabled={!props.turnstileSuccess}
                  tabIndex={3}
                >
                  {translate('ButtonEnter')}
                </button>
              ) : (
                <Progress animated color="primary" value={100} />
              )}
              <TurnstileComponent setTurnstileSuccess={props.setTurnstileSuccess} />
              <div className="jjnet-messages">
                <Alert
                  color="danger"
                  isOpen={error.open}
                  toggle={() => setError({ open: false })}
                >
                  {error.message}
                </Alert>
              </div>
            </Form>
          </div>
        </CSSTransition>
      </div>
    </div>
  );
};

export default WithCaptcha(LoginForm, { useInsideForm: true });
